import React from 'react';
import Grid from '@material-ui/core/Grid/Grid';
import TableAdv from '../../components/TableAdv';
import HttpClient from '../../myapi';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import IconButton from '@material-ui/core/IconButton/IconButton';
import { IconPrint } from '../../Icons';
// import TextField from '@material-ui/core/TextField/TextField';
import PrintTitle from '../../components/PrintTitle';

const header = [
    { label: 'Name of Person', key: 'name', type: 1 },
    { label: 'Earned', key: 'earn', type: 2 },
    { label: 'TDS (15%)', key: 'tdsAmt', type: 2 },
    { label: 'Payment', key: 'payment', type: 2 },
    { label: 'Bank', key: 'bank', type: 2 },
    { label: 'Branch', key: 'branch', type: 2 },
    { label: 'IFSC', key: 'ifsc', type: 2 },
    { label: 'Account No.', key: 'acct', type: 2 },
];
class ViewPayment extends React.Component {
    state = {
        data: [],
    };

    componentDidMount() {
        HttpClient.get('/Payment/getPayment').then(res => {
            this.calculateTds(res);
        });
    }

    calculateTds(persons) {
        persons.map(person => {
            const tdsAmt = (person.earn * 0.15).toFixed(2);
            return (
                (person.tdsAmt = tdsAmt),
                (person.payment = (person.earn - tdsAmt).toFixed(2))
            );
        });

        this.setState({
            data: persons,
        });
    }

    print(){
        window.print()
    }

    render() {
        const { data } = this.state;
        return (
            <Grid justify="center" container>
                <Grid id="print-content" xs={12} sm={12} md={10} item>
                    <PrintTitle title="Commision Payment List" date="Nov-2018"/>
                    <TableAdv 
                        data={data} 
                        header={header} 
                        paginate={true} 
                        toolbarComponent={<Toolbar print={this.print}/> }
                    />
                </Grid>
            </Grid>
        );
    }
}
export default ViewPayment;

const padding6 = {
    padding: 6,
    margin: '1px 0',
};
const Toolbar = ({ print }) => (
    <Grid container style={{ flexGrow: 1 }}>
        <Grid item>
            <Tooltip title="Print">
                <IconButton color="primary" style={padding6} onClick={print}>
                    <IconPrint />
                </IconButton>
            </Tooltip>
        </Grid>
        <Grid item>
        </Grid>
    </Grid>
);
